
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33 43"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.86 7.65l9.86 7-14.51 20.51c-.295.409-1.654 2.496-2.398 3.038l-.112.072-7.51 3.67a2.11 2.11 0 01-2.17-.06 2.23 2.23 0 01-1.016-2l.016-.17 1.36-8.29a2.67 2.67 0 01.46-1.19l1.335-1.882.145-.208L17.86 7.65zM2.519 31.458a.31.31 0 00-.141.161l-.018.071-.81 5.18 3.84 2.73 4.72-2.42a.3.3 0 00.117-.476l-.047-.044L6.4 34l-3.6-2.55a.31.31 0 00-.281.008zm18.768-15.046l-.077.098L10.86 31.1a1.14 1.14 0 00.27 1.6 1.15 1.15 0 001.529-.168l.08-.102L23.09 17.8a1.16 1.16 0 00-.18-1.532l-.1-.078c-.484-.34-1.14-.213-1.522.222zM22.62.94a2.24 2.24 0 012.97-.62l.14.09 6.22 4.42a2.22 2.22 0 01.636 2.936l-.106.164-3 4.26-9.86-7 3-4.25z"}})])
          )
        }
      }
    